import { Colors } from "@/enums/Colors";
import { Spinner } from "@/external/ensolvers-core-frontend-mui-v5/components/Common/Spinner";
import i18n from "@/i18n/config";
import WarningSVG from "@/images/inactive-indicator-orange.svg";
import { DataRoomFile } from "@/models/data-room/DataRoomFile";
import { ProcessingState } from "@/models/data-room/ProcessingState";
import { FILE_CANNOT_BE_ANALYZED_MESSAGE } from "@/utils/DataRoomUtils";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LazoTooltip from "../utils/LazoTooltip";
import { findPathByStaticId } from "./DataRoomCategoriesDefines";

export function getSuggestedFolderValue(file: DataRoomFile, hideTooltip?: boolean) {
  if (!file.suggestedStaticId) return <>{i18n.t("virtualDataRooms:utils.noFolderSuggested")}</>;

  const hideTooltipInternal = hideTooltip || file.processingState === ProcessingState.CANNOT_BE_ANALYZED;

  switch (file.processingState) {
    case ProcessingState.NOT_PROCESSED:
      return <Typography>{i18n.t("virtualDataRooms:utils.queuedForAnalysis")}</Typography>;
    case ProcessingState.PROCESSING_SUGGESTED_FOLDER:
      return (
        <Box display="flex" alignItems="center" gap="0.25rem">
          <Spinner size="1rem" sx={{ color: Colors.BLUE_4763F4 }} />
          <Typography>{i18n.t("virtualDataRooms:utils.analyzing")}</Typography>
        </Box>
      );
    default:
      return (
        <Box display="flex" alignItems="center" gap="0.5rem">
          {file.processingState === ProcessingState.CANNOT_BE_ANALYZED && (
            <LazoTooltip
              title={FILE_CANNOT_BE_ANALYZED_MESSAGE}
              offset={[0, 10]}
              maxWidth="50vw"
              fontSize="0.75rem"
              fontColor={Colors.BLACK}
            >
              <img src={WarningSVG.src} alt="warning-icon" style={{ width: "22px", height: "22px" }} />
            </LazoTooltip>
          )}
          {hideTooltipInternal ? (
            <Typography className="filename-container">{findPathByStaticId(file.suggestedStaticId)}</Typography>
          ) : (
            <LazoTooltip
              title={
                <>
                  {i18n.t("virtualDataRooms:utils.suggestedFolderTooltip")} <br />
                  {findPathByStaticId(file.suggestedStaticId)}
                </>
              }
            >
              <Typography className="filename-container">{findPathByStaticId(file.suggestedStaticId)}</Typography>
            </LazoTooltip>
          )}
        </Box>
      );
  }
}
